import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { openRubber, RECYCLED_RUBBER_URL } from "../../lib/track";

const subLinks = [
  {
    id: "shop-playground",
    label: "Playground Mulch",
    href: "https://recycledrubber.com/product/kindermulch-playground-rubber-mulch/",
  },
  {
    id: "shop-landscape",
    label: "Landscape Mulch",
    href: "https://recycledrubber.com/product/rhinomulch-landscape-rubber-mulch/",
  },
  {
    id: "shop-bulk",
    label: "Bulk & Commercial",
    href: "https://recycledrubber.com/bulk-rubber-mulch-chicagoland/",
  },
];

export default function BigCTA() {
  return (
    <section
      data-testid="big-cta-section"
      className="relative w-full py-32 sm:py-44 px-6 bg-[#0F0F0F] overflow-hidden border-t border-[#1A1A1A]"
    >
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(196,69,28,0.10), transparent 65%)",
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0 }}
          className="font-marker text-[#E8E5DE] text-5xl sm:text-7xl md:text-8xl leading-[0.95]"
        >
          You've seen
          <br />
          enough.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0, delay: 0.15 }}
          className="text-lg sm:text-xl text-[#A3A3A3] mt-8 max-w-xl mx-auto"
        >
          Stop replanting the same mistake every spring.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0, delay: 0.3 }}
          className="mt-14"
        >
          <button
            onClick={() => openRubber("end-cycle-big", "big-cta", RECYCLED_RUBBER_URL)}
            data-testid="end-cycle-big-button"
            className="group inline-flex items-center gap-4 bg-[#C4451C] hover:bg-[#A13815] text-[#0F0F0F] font-semibold tracking-wider uppercase text-sm sm:text-base px-8 sm:px-12 py-5 sm:py-6 transition-colors duration-300"
            style={{ letterSpacing: "0.15em" }}
          >
            End the Wood Mulch Cycle
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0, delay: 0.5 }}
          className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10"
        >
          {subLinks.map((l) => (
            <button
              key={l.id}
              onClick={() => openRubber(l.id, "big-cta-sub", l.href)}
              data-testid={`${l.id}-link`}
              className="text-xs sm:text-sm tracking-[0.25em] uppercase text-[#A3A3A3] hover:text-[#C4451C] underline-offset-8 hover:underline transition-colors"
            >
              {l.label}
            </button>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
